import { useEffect, useState } from "react";
import queryString from 'query-string';
import history from "../../history";
import moment from "moment";
import { Table, Card, Row, Col, Drawer, message, Modal, Spin, Form, Input, InputNumber, Select, Space, Button, Tooltip as TooltipAnd } from 'antd';
import basvuruHarcDenetimKriteriGuncelle from "../../services/basvuruHarcDenetimKriteriGuncelle";
import getbasvuruHarcDenetimKriterList from "../../services/basvuruHarcDenetimKriterList";
import gonderimDurumu from "../../hooks/gonderimDurum";
import { isNullOrEmptyOrUndefined } from "../Helpers/Util";

const { Option } = Select;

const parsed = queryString.parse(history.location.search);


function onChange(value, key, record) {
  record[key] = value;
  console.log('changed', value);
}

const HarcDenetimKriteriForm = () => {
  const [form] = Form.useForm();
  const [selectionType, setSelectionType] = useState('checkbox');
  const [editingKey, setEditingKey] = useState('');
  const [spining, setSpining] = useState(false);
  const [visible, setVisible] = useState(false);
  const [basvuruHarcDenetimKriteriList, setBasvuruHarcDenetimKriteriList] = useState([]);
  const basvuruId = parseInt(parsed.basvuruId);
  const originData = [];
  const [dates, setDates] = useState([moment(), moment()]);
  const [queryDates, setQueryDates] = useState([undefined, undefined]);
  let [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const { gonderimDurumuEnum } = gonderimDurumu();

  const load = async () => {
    var stateId = (isNullOrEmptyOrUndefined(parsed.stateId) ? 0 : parseInt(parsed.stateId));

    setSpining(true);
    await getbasvuruHarcDenetimKriterList(basvuruId, stateId).then(res => {
      setBasvuruHarcDenetimKriteriList(res.data.result);
    });
    setVisible(true);
    setSpining(false);
    setQueryDates(dates);
  }
  useEffect(() => {
    load();
  }, []);



  function defaultValueSetter(defaultValue) {
    if (defaultValue > 0) {
      return defaultValue;
    } else {
      return 0;
    }
  };

  const columns = [
    {
      title: 'Harç Türü',
      dataIndex: 'harcTuru',
      width: '80%',
      editable: false,
    },
    {
      title: 'Harç Tutarı',
      dataIndex: 'harcTutari',
      width: '20%',
      key: 'harcTutari',
      render: (text, record, value) => (
        <div>
          <InputNumber
            defaultValue={defaultValueSetter(record.harcTutari)}
            disabled={record.gonderimDurumuId === gonderimDurumuEnum.Gonderilecek ? false : true}
            onChange={value => onChange(value, 'harcTutari', record)}
            precision={2}
            min={0}
            step={0.01}
          />
        </div>
      )
    }
  ];

  const reloadLoc = () => {
    window.parent.location.reload();
  }

  const success = (text) => {
    message.success(text).then(reloadLoc);
  };

  const error = (text) => {
    message.error(text);
  };





  const harcDenetimKriteriOnayla = async () => {
    setSpining(true);
    var selectedRows = basvuruHarcDenetimKriteriList;
    var requestModel = {};
    if (selectedRows.length > 0) {
      requestModel.BasvuruId = basvuruId;
      requestModel.BasvuruHarcRequestList = [];
      for (var i = 0; i < selectedRows.length; i++) {
        requestModel.BasvuruHarcRequestList.push({
          "ObjectId": selectedRows[i].objectid,
          "HarcTutari": selectedRows[i].harcTutari
        });
      }
      //TODO Metod çağrılacak
      var resultval = false;
      await basvuruHarcDenetimKriteriGuncelle(requestModel)//then(res => { if(res.data.success==true){success('İşlem başarı ile tamamlandı.').then(window.parent.location.reload())}else{ error(res.data.message).then(setSpining(false))}})
        .then(res => { res.data.success ? success('İşlem başarı ile tamamlandı.') : error(res.data.message); setSpining(false); })
        .catch(ex => {
          setSpining(false);
        })
      window.parent.location.reload();
    }

    setSpining(false);

  }


  return <Spin tip={"Veriler Yükleniyor"} spinning={spining} >
    <Card bodyStyle={{ padding: "10" }}
    //style={{ margin: "20px" }}
    //title={<h4 style={{ fontWeight: "bolder", color: "white" }}>Harç Bilgileri Formu</h4>}
    //</Spin>className="ant-card-head-title-large"
    >
      <Row gutter={16}>
        {visible &&
          <Table scroll={{}} rowKey={"objectid"} dataSource={basvuruHarcDenetimKriteriList}
            columns={columns}
            title={() => <div style={{ display: "flex", justifyContent: "space-between" }}><h3 style={{ fontWeight: "bolder" }}>{''}</h3></div>}
            pagination={false}
            onChange={
              (filters, sorter, extra) => {
                if (extra.currentDataSource.length < originData.length) {
                }
                else {
                }
              }
            }
          />
        }
      </Row>
      <Col offset={19}  >
        <Row gutter={16}  >{
          <Button
            onClick={harcDenetimKriteriOnayla}
            type="primary"
            style={{
              marginTop: 5
            }}
          >
            Kaydet
          </Button>
        }
        </Row>
      </Col>
    </Card>
  </Spin>

}
export default HarcDenetimKriteriForm;